import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/requisitions/create')({
  component: CreateRequisitionPage,
});

function CreateRequisitionPage() {
  return (
    <div className="container mx-auto px-6 py-8">
      <h1 className="text-3xl font-bold mb-6">Create New Requisition</h1>
      <p className="text-muted-foreground mb-4">
        Create a new job requisition with all required details and specifications.
      </p>
      <div className="bg-muted/30 border rounded-lg p-6 mt-6">
        <p className="text-sm text-muted-foreground">
          This page is under development. Requisition creation form will be available soon.
        </p>
      </div>
    </div>
  );
}
